import { useGetArticles } from "modules/article/api";
import { Article } from "modules/article/types/article.interface";
import { useCallback, useMemo, useState } from "react";
import ArticleTable, {
  RowObjArticle,
} from "../default/components/articleTable";

const Articles = () => {
  const [searchName, setSearchName] = useState<string | undefined>(undefined);
  const { data, hasNextPage, fetchNextPage, fetchPreviousPage, isLoading } = useGetArticles(searchName, 100);
  const [currentPage, setCurrentPage] = useState(1);
  
  // Memoize the current page data
  const flatData = useMemo(() => 
    data?.pages[currentPage - 1]?.data ?? [], 
    [data?.pages, currentPage]
  );

  // Memoize the formatted data
  const formattedData = useMemo((): RowObjArticle[] => {
    return flatData.map((item: Article) => ({
      id: item._id,
      label: item.label,
      description: item.description || null,
      priceHT: item.priceHT ? item.priceHT.toString() : null,
      priceTTC: item.priceTTC ? item.priceTTC.toString() : null,
      code: item.code ? item.code : "-",
    }));
  }, [flatData]);

  const handleFetchNextPage = useCallback(() => {
    if (hasNextPage) {
      fetchNextPage();
      setCurrentPage(prev => prev + 1);
    }
  }, [hasNextPage, fetchNextPage]);

  const handleFetchPrevPage = useCallback(() => {
    if (currentPage > 1) {
      fetchPreviousPage();
      setCurrentPage(prev => prev - 1);
    }
  }, [currentPage, fetchPreviousPage]);

  const totalPage = data?.pages[0]?.count ? Math.ceil(data.pages[0].count / 100) : 1;

  return (
    <div>
      <div className="mt-5">
        <ArticleTable
          tableData={formattedData}
          searchName={searchName || ""}
          setSearchName={setSearchName}
          currentPage={currentPage}
          totalPage={totalPage}
          hasNextPage={hasNextPage}
          handleFetchNextPage={handleFetchNextPage}
          handleFetchPrevPage={handleFetchPrevPage}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default Articles;
